import { useMemo } from 'react';
import { useQuery } from 'react-query';
import useAccount from '@ubeya/shared/hooks/account/useAccount';
import useConvertTimeRange from '@ubeya/shared/hooks/useConvertTimeRange';
import * as api from '@ubeya/shared/services/api';

const useSupplierInvoice = ({ supplierId, timeRange, enabled }) => {
  const { accountId } = useAccount();
  const timeRangeValue = useConvertTimeRange(timeRange);
  const storeKey = ['supplier', 'invoices', accountId, supplierId, timeRangeValue];

  const { isLoading, data: { data: payroll = [] } = {} } = useQuery(
    storeKey,
    () => api.fetchSupplierInvoices({ accountId, ...timeRangeValue, supplierId }),
    {
      enabled,
      staleTime: 0
    }
  );

  const payrollTotal = useMemo(
    () => payroll.reduce((acc, { totalWithAdditional = 0 } = {}) => acc + totalWithAdditional, 0),
    [payroll]
  );

  return { payroll, payrollTotal, isLoading };
};

export default useSupplierInvoice;
